import { ENV_VARS } from '@/env';

export const OIDC_AUTH_ROUTES = {
  OIDC_AUTH_CALLBACK: '/auth/callback',
  OIDC_AUTH_RESET: '/sign-in',
} as const;

export const IDENTITY_PROFILE_URL = `${ENV_VARS.REACT_APP_OIDC_AUTHORITY}/user/profile`;
